"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateGas = exports.staticCallPopulatedTransaction = exports.executePopulatedTransaction = exports.populateTransactionGas = void 0;
var config_1 = require("./config/config");
var _types_1 = require("./types");
var ethers_1 = require("ethers");
function populateTransactionGas(tx, config, signer, action) {
    var _a, _b;
    if (action === void 0) { action = "default"; }
    return __awaiter(this, void 0, void 0, function () {
        var gasRecommendation, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    gasRecommendation = config_1.CHAIN_GAS_RECOMMENDATION[config.network][action] !== undefined ?
                        (_a = config_1.CHAIN_GAS_RECOMMENDATION[config.network][action]) === null || _a === void 0 ? void 0 : _a.limit :
                        (_b = config_1.CHAIN_GAS_RECOMMENDATION[config.network]["default"]) === null || _b === void 0 ? void 0 : _b.limit;
                    _c = tx;
                    return [4 /*yield*/, (0, exports.estimateGas)(tx, config, signer)];
                case 1:
                    _c.gasLimit = _d.sent();
                    tx.gasLimit = gasRecommendation && tx.gasLimit.lte(ethers_1.BigNumber.from(gasRecommendation)) ?
                        ethers_1.BigNumber.from(gasRecommendation) :
                        tx.gasLimit;
                    return [2 /*return*/, tx];
            }
        });
    });
}
exports.populateTransactionGas = populateTransactionGas;
var executePopulatedTransaction = function (populatedTxn, signer) { return __awaiter(void 0, void 0, void 0, function () {
    var tx, _a, _b, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                _b = (_a = signer).populateTransaction;
                return [4 /*yield*/, populatedTxn];
            case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
            case 2:
                tx = _c.sent();
                return [2 /*return*/, signer.sendTransaction(tx)];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, Promise.reject(error_1 instanceof Error ? error_1 : new Error(error_1))];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.executePopulatedTransaction = executePopulatedTransaction;
function staticCallPopulatedTransaction(populatedTxn, signer) {
    return __awaiter(this, void 0, void 0, function () {
        var txn, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, populatedTxn];
                case 1:
                    txn = _a.sent();
                    return [4 /*yield*/, signer.call(txn)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_2 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_2 instanceof Error ? error_2 : new Error(error_2))];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.staticCallPopulatedTransaction = staticCallPopulatedTransaction;
var DEFAULT_SURPLUS = 30; // 30%
var POLYGON_SURPLUS = 60; // 60%
var estimateGas = function (tx, config, signer, gasSurplus) { return __awaiter(void 0, void 0, void 0, function () {
    var estimatedGas, _a, error_3, network;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                estimatedGas = ethers_1.BigNumber.from((_b = config_1.CHAIN_GAS_RECOMMENDATION[config.network]["default"]) === null || _b === void 0 ? void 0 : _b.limit);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 7]);
                if (!signer) return [3 /*break*/, 3];
                return [4 /*yield*/, signer.estimateGas(tx)];
            case 2:
                _a = _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, config.provider.estimateGas(tx)];
            case 4:
                _a = _c.sent();
                _c.label = 5;
            case 5:
                estimatedGas = _a;
                return [3 /*break*/, 7];
            case 6:
                error_3 = _c.sent();
                console.error('[AnteSDK] Failed to estimate gas', error_3);
                return [3 /*break*/, 7];
            case 7:
                network = config.network;
                if (network === _types_1.Network.polygon) {
                    return [2 /*return*/, estimatedGas.add(estimatedGas.mul(POLYGON_SURPLUS).div(100))];
                }
                return [2 /*return*/, estimatedGas.add(estimatedGas.mul(gasSurplus || DEFAULT_SURPLUS).div(100))];
        }
    });
}); };
exports.estimateGas = estimateGas;
